import * as React from "react";
import { CustomFilterRenderProps } from "Components/ScrollableTable/components/ScrollableTableHeader";
import { filterControlTestId } from "Components/ScrollableTable/components/filterControlTestId";
import { Input, Row, Button } from "antd";
import { useTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";

interface FolderMetadataSearchFilterProps extends CustomFilterRenderProps {
  placeholder?: string;
  testIdSuffix?: string;
}

export const FolderMetadataSearchFilter: React.FC<FolderMetadataSearchFilterProps> = (props) => {
  const { t } = useTranslation(I18N_NS.PROJECT);
  const tid = (base: string) => filterControlTestId(base, props.testIdSuffix);
  const [value, setValue] = React.useState<string>((props.selectedFilters?.[0] as string) ?? "");

  React.useEffect(() => {
    const v = (props.selectedFilters?.[0] as string) ?? "";
    setValue(v);
  }, [props.selectedFilters]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value: v } = e.target;
    setValue(v);
    props.setFilters(v ? [v] : []);
  };

  const handleReset = () => {
    props.clearFilters();
    setValue("");
  };

  return (
    <div>
      <div className="mb-sm">
        <Input
          size="small"
          data-testid={tid("folder-metadata-search-filter-input")}
          value={value}
          onChange={handleChange}
          onPressEnter={props.confirm}
          placeholder={props.placeholder ?? t("Search")}
        />
      </div>
      <Row justify="space-between">
        <Button size="small" data-testid={tid("folder-metadata-search-filter-reset")} onClick={handleReset}>
          {t("Reset")}
        </Button>
        <Button
          size="small"
          type="primary"
          data-testid={tid("folder-metadata-search-filter-ok")}
          onClick={props.confirm}
        >
          {t("Ok")}
        </Button>
      </Row>
    </div>
  );
};
